export const translations = {
	'You have unsaved content. You will lose the changes if you click close. Click cancel and save the changes if you want to keep the changes.':
		{
			no: 'Du har ulagret innhold, du vil miste endringen hvis du klikker Lukk. Trykk avbryt og lagre endringen hvis du vil beholde endringene.',
		},
	'Pdf': {
		no: 'Pdf',
	},
	'Has attachments': {
		no: 'Har vedlegg',
	},
	'There are 1 or more services that have a system warning. These warnings can be agent in error, agent in warning, agent/asset in maintenance and qualifier error. Click to see the affected services.':
		{
			no: 'Det er 1 eller flere tjenester som har systemadvarsel. Disse advarslene kan vçre feil på agent, agent i advarsel, agent/ressurs i vedlikeholds- og tjenestepunktfeil. Klikk for å se de berørte tjenestene.',
		},
	'There are 1 or more assets that have a system warning. These warnings can be agent in error, agent in warning and monitor error. Click to see the affected assets.':
		{
			no: 'Det er 1 eller flere ressurser som har system advarsel. Disse advarslene kan vçre feil på agent, agent i advarsel og monitorfeil. Klikk for å se de berørte ressursene.',
		},
	'Warning operator': {
		no: 'Advarseloperator',
	},
	'Breaches': {
		no: 'Brudd',
	},
	'Metric error': {
		no: 'Metrikkfeil',
	},
	'Request sent to agent. Note that system agent and agents that are down will be ignored in the request.': {
		no: 'Melding sendt til agent. Systemagent og agenter som er nede blir ignorert.',
	},
	'This will reset healthindex for all reasons to this monitor': {
		no: 'Dette vil resette helse for alle årsåker for monitor',
	},
	'Request for resetting healthindex for selected monitor is sent to agent': {
		no: 'Tilbakestilling av helseindeksen for valgt monitor er sendt til agenten',
	},
};
